import { FC, useRef, useState } from "react";

import Stepper from "../molecules/Stepper";
import BellyChoice from "../BellyChoice";
import MeasuredBy from "../molecules/MeasuredBy";

import { GENDERS, MODAL_STEPS } from "../../constants/modal";

import { useTranslation } from "react-i18next";

import belly_1_female from "../../assets/questionnaire/belly/belly-1-female.svg";
import belly_2_female from "../../assets/questionnaire/belly/belly-2-female.svg";
import belly_3_female from "../../assets/questionnaire/belly/belly-3-female.svg";

import belly_1_male from "../../assets/questionnaire/belly/belly-1-male.svg";
import belly_2_male from "../../assets/questionnaire/belly/belly-2-male.svg";
import belly_3_male from "../../assets/questionnaire/belly/belly-3-male.svg";

import victoria_selected_1 from "../../assets/questionnaire/belly/victoria-assets/selected/VB_SIZE&FIT_ILLUSTRATIONS-12.svg";
import victoria_selected_2 from "../../assets/questionnaire/belly/victoria-assets/selected/VB_SIZE&FIT_ILLUSTRATIONS-13.svg";
import victoria_selected_3 from "../../assets/questionnaire/belly/victoria-assets/selected/VB_SIZE&FIT_ILLUSTRATIONS-14.svg";

import victoria_unselected_1 from "../../assets/questionnaire/belly/victoria-assets/unselected/VB_SIZE&FIT_ILLUSTRATIONS-18.svg";
import victoria_unselected_2 from "../../assets/questionnaire/belly/victoria-assets/unselected/VB_SIZE&FIT_ILLUSTRATIONS-19.svg";
import victoria_unselected_3 from "../../assets/questionnaire/belly/victoria-assets/unselected/VB_SIZE&FIT_ILLUSTRATIONS-20.svg";

import modern_sillhouette_1 from "../../assets/questionnaire/belly/modern/F-VENTRE_1.svg";
import modern_sillhouette_2 from "../../assets/questionnaire/belly/modern/F-VENTRE_2.svg";
import modern_sillhouette_3 from "../../assets/questionnaire/belly/modern/F-VENTRE_3.svg";

import ogier_modern_1_female from "../../assets/questionnaire/belly/ogier/female/F-VENTRE_1.svg";
import ogier_modern_2_female from "../../assets/questionnaire/belly/ogier/female/F-VENTRE_2.svg";
import ogier_modern_3_female from "../../assets/questionnaire/belly/ogier/female/F-VENTRE_3.svg";

import ogier_modern_1_male from "../../assets/questionnaire/belly/ogier/male/M-VENTRE_1.svg";
import ogier_modern_2_male from "../../assets/questionnaire/belly/ogier/male/M-VENTRE_2.svg";
import ogier_modern_3_male from "../../assets/questionnaire/belly/ogier/male/M-VENTRE_3.svg";

import givenchy_modern_1_male_selected from "../../assets/questionnaire/belly/givenchy/male/selected/M-VENTRE_1.svg";
import givenchy_modern_2_male_selected from "../../assets/questionnaire/belly/givenchy/male/selected/M-VENTRE_2.svg";
import givenchy_modern_3_male_selected from "../../assets/questionnaire/belly/givenchy/male/selected/M-VENTRE_3.svg";

import givenchy_modern_1_male_unselected from "../../assets/questionnaire/belly/givenchy/male/unselected/M-VENTRE_1.svg";
import givenchy_modern_2_male_unselected from "../../assets/questionnaire/belly/givenchy/male/unselected/M-VENTRE_2.svg";
import givenchy_modern_3_male_unselected from "../../assets/questionnaire/belly/givenchy/male/unselected/M-VENTRE_3.svg";

import givenchy_modern_1_female_unselected from "../../assets/questionnaire/belly/givenchy/female/unselected/F-VENTRE_1.svg";
import givenchy_modern_2_female_unselected from "../../assets/questionnaire/belly/givenchy/female/unselected/F-VENTRE_2.svg";
import givenchy_modern_3_female_unselected from "../../assets/questionnaire/belly/givenchy/female/unselected/F-VENTRE_3.svg";

import givenchy_modern_1_female_selected from "../../assets/questionnaire/belly/givenchy/female/selected/F-VENTRE_1.svg";
import givenchy_modern_2_female_selected from "../../assets/questionnaire/belly/givenchy/female/selected/F-VENTRE_2.svg";
import givenchy_modern_3_female_selected from "../../assets/questionnaire/belly/givenchy/female/selected/F-VENTRE_3.svg";

import {
  titleStyles,
  disabledStylesContinue,
  activeStylesContinue,
  welcomeScreenUI,
} from "../../configs";
import {
  capitalizeFirstLetter,
  handleAdditionalBrands,
  useIsMobile,
} from "../../utils";
import { useUserContext } from "../../store/userContext";
import { findBrandByDomain } from "../../configs/configLoader";
import { hoverStylesContinue } from "../../configs/stylesLoader";
import { ArrowForward as ChevronRight } from "@mui/icons-material";
import ScanCTA from "../DrawerModal/components/ScanCTA";

import "./index.css";

interface IPropsStepBelly {
  step: {
    number: number;
  } | null;
  gender?: string;
  nextStep: () => void;
  setStep: (
    value: React.SetStateAction<{
      number: number;
    } | null>,
  ) => void;
  setPreviousStep: React.Dispatch<
    React.SetStateAction<{
      number: number;
    } | null>
  >;
  value: {
    current: number;
  };
  descriptionStyles: React.CSSProperties;
}

const StepBelly: FC<IPropsStepBelly> = ({
  step,
  gender,
  nextStep,
  setStep,
  setPreviousStep,
  value,
  descriptionStyles,
}) => {
  const { t } = useTranslation("components/belly");

  const isMobile = useIsMobile();

  const userContext = useUserContext() || null;

  const [selected, setSelected] = useState<number | undefined>(value.current);
  const [hovered, setHovered] = useState(false);

  const brandDefined = findBrandByDomain();

  const continueButtonRef = useRef<HTMLButtonElement | null>(null);

  const isIntersport = brandDefined?.name === "Intersport";
  const isVB = brandDefined?.name === "Victoria Beckham";
  const isSRP = brandDefined?.name === "SRP";
  const isHast = brandDefined?.name === "Hast";
  const isPeserico = brandDefined?.name === "Peserico";
  const isGivenchy = brandDefined?.name === "Givenchy";
  const isTDF = brandDefined?.name === "TDF";

  const isMobileVB = isMobile && isVB;
  const isGivenchyDesktop = isGivenchy && !isMobile;
  const isGivenchyMobile = isGivenchy && isMobile;

  const continueButtonStyles = !selected
    ? disabledStylesContinue
    : activeStylesContinue;

  const handleFemaleSilhouettesMap = (isSelected: boolean) => {
    const silhouettesMap: Record<string, (string | null)[]> = {
      "Victoria Beckham": [
        null,
        isSelected ? victoria_selected_1 : victoria_unselected_1,
        isSelected ? victoria_selected_2 : victoria_unselected_2,
        isSelected ? victoria_selected_3 : victoria_unselected_3,
      ],
      Ogier: [
        null,
        ogier_modern_1_female,
        ogier_modern_2_female,
        ogier_modern_3_female,
      ],
      Givenchy: [
        null,
        isSelected
          ? givenchy_modern_1_female_selected
          : givenchy_modern_1_female_unselected,
        isSelected
          ? givenchy_modern_2_female_selected
          : givenchy_modern_2_female_unselected,
        isSelected
          ? givenchy_modern_3_female_selected
          : givenchy_modern_3_female_unselected,
      ],
      Modern: [
        null,
        modern_sillhouette_1,
        modern_sillhouette_2,
        modern_sillhouette_3,
      ],
    };

    return silhouettesMap;
  };

  const handleMaleSilhouettesMap = (isSelected: boolean) => {
    const silhouettesMap: Record<string, (string | null)[]> = {
      Ogier: [
        null,
        ogier_modern_1_male,
        ogier_modern_2_male,
        ogier_modern_3_male,
      ],
      Givenchy: [
        null,
        isSelected
          ? givenchy_modern_1_male_selected
          : givenchy_modern_1_male_unselected,
        isSelected
          ? givenchy_modern_2_male_selected
          : givenchy_modern_2_male_unselected,
        isSelected
          ? givenchy_modern_3_male_selected
          : givenchy_modern_3_male_unselected,
      ],
      Default: [null, belly_1_male, belly_2_male, belly_3_male],
    };

    return silhouettesMap;
  };

  const handleMaleImage = (item: number) => {
    const isSelected = selected === item;

    if (gender === GENDERS.F) return handleFemaleImage(item);

    const relatedSilhouettes =
      handleMaleSilhouettesMap(isSelected)[brandDefined?.name || "Default"] ||
      handleMaleSilhouettesMap(isSelected)["Default"];

    return relatedSilhouettes[item] ?? relatedSilhouettes[1];
  };

  const handleFemaleImage = (item: number) => {
    const isSelected = selected === item;
    const isAdditionalBrands = handleAdditionalBrands(brandDefined?.name);

    if (isAdditionalBrands || brandDefined?.name === "Givenchy") {
      const relatedSilhouettes =
        handleFemaleSilhouettesMap(isSelected)[
          brandDefined?.name || "Modern"
        ] || handleFemaleSilhouettesMap(isSelected)["Modern"];

      return relatedSilhouettes[item] ?? relatedSilhouettes[1];
    }

    const defaultImages = [
      null,
      belly_1_female,
      belly_2_female,
      belly_3_female,
    ];
    return defaultImages[item] ?? defaultImages[1];
  };

  const handleImagesGap = () => {
    if (isGivenchy) return "20px";
    if (isTDF) return "16px";
    if (isMobileVB) return "0px";
    return "8px";
  };

  const CTAStyles: React.CSSProperties = {
    ...continueButtonStyles,
    ...(hovered && selected ? hoverStylesContinue : {}),
    marginTop: isGivenchy && isMobile ? "60px" : "20px",
    textTransform:
      continueButtonStyles.textTransform === "capitalize"
        ? "none"
        : continueButtonStyles.textTransform,
    padding: isTDF ? "0" : isPeserico ? "12px 16px" : isVB ? "7px" : "16px",
    height: isTDF ? "28px" : isVB ? "30px" : "auto",
    maxHeight: isTDF ? "28px" : isGivenchy ? "40px" : "fit-content",
    position: isGivenchyDesktop ? "fixed" : "relative",
    bottom: isGivenchyDesktop ? "150px" : 0,
    width: isGivenchyDesktop ? "calc(100% - 160px)" : "",
  };

  const arrowContainerStyle: React.CSSProperties = {
    display: "inline-block",
    width: hovered && selected ? 16 : 0,
    overflow: "hidden",
    verticalAlign: "middle",
    transition: "width 160ms ease",
  };

  const iconStyle: React.CSSProperties = {
    width: 16,
    height: 16,
    opacity: hovered && selected ? 1 : 0,
    transform: hovered && selected ? "translateX(0)" : "translateX(-6px)",
    transition: "opacity 160ms ease, transform 160ms ease",
    display: "inline-block",
    verticalAlign: "middle",
    pointerEvents: "none",
  };

  return (
    <>
      <div
        className="belly-description"
        style={{
          ...descriptionStyles,
          textAlign: titleStyles.textAlign as React.CSSProperties["textAlign"],
          justifyContent:
            titleStyles.textAlign as React.CSSProperties["justifyContent"],
          textTransform:
            descriptionStyles.textTransform === "capitalize"
              ? "none"
              : (descriptionStyles.textTransform as React.CSSProperties["textTransform"]),
          fontStyle: (welcomeScreenUI.input_fields.title as any)
            .fontStyle as React.CSSProperties["fontStyle"],
          marginTop: isGivenchy
            ? "10px"
            : isTDF
              ? "0px"
              : descriptionStyles.marginTop,
          marginBottom: isGivenchyMobile ? "40px" : 0,
        }}
      >
        <p
          style={{
            margin: 0,
          }}
        >
          {isVB
            ? "Hip Shape"
            : descriptionStyles.textTransform === "capitalize"
              ? capitalizeFirstLetter(t("description"))
              : t("description")}
        </p>
      </div>
      <div
        tabIndex={-1}
        className="belly"
        style={{
          marginTop: isTDF ? "5px" : isMobile ? "20px" : "40px",
          gap: isTDF ? "0px" : isMobile ? "10px" : "30px",
        }}
      >
        <div
          className="body"
          style={{
            gap: handleImagesGap(),
          }}
        >
          <BellyChoice
            image={handleMaleImage(1)}
            onClick={() => {
              value.current = 1;
              setSelected(1);

              requestAnimationFrame(() => {
                continueButtonRef.current?.focus();
              });
            }}
            text={t("size.one")}
            isSelected={selected === 1}
            gender={gender}
            type="belly"
          />
          <BellyChoice
            image={handleMaleImage(2)}
            onClick={() => {
              value.current = 2;
              setSelected(2);

              requestAnimationFrame(() => {
                continueButtonRef.current?.focus();
              });

              setTimeout(() => {
                continueButtonRef.current?.focus();
              }, 0);
            }}
            text={t("size.two")}
            isSelected={selected === 2}
            gender={gender}
            type="belly"
          />
          <BellyChoice
            image={handleMaleImage(3)}
            onClick={() => {
              value.current = 3;
              setSelected(3);

              requestAnimationFrame(() => {
                continueButtonRef.current?.focus();
              });
            }}
            text={t("size.three")}
            isSelected={selected === 3}
            gender={gender}
            type="belly"
          />
        </div>
        <div className="controls">
          {!isSRP && !isVB && !isGivenchy && !isTDF && (
            <Stepper
              stepsNum={isHast ? 4 : gender === GENDERS.M ? 3 : 2}
              step={1}
              key={1}
            />
          )}
          <button
            tabIndex={0}
            ref={continueButtonRef}
            type="button"
            disabled={!selected}
            className={`continue-button step-belly-button`}
            onMouseEnter={(e) => {
              if (isMobile) return;
              setHovered(true);
              if (selected) {
                Object.assign(e.currentTarget.style, hoverStylesContinue);
              }
            }}
            onMouseLeave={(e) => {
              setHovered(false);
              if (selected) {
                Object.assign(e.currentTarget.style, continueButtonStyles);
              }
            }}
            onClick={() => nextStep()}
            style={CTAStyles}
          >
            <div
              style={{ display: "inline-flex", alignItems: "center", gap: 0 }}
            >
              {continueButtonStyles.textTransform === "capitalize"
                ? capitalizeFirstLetter(
                    t("continue", { ns: "components/intro" }),
                  )
                : t("continue", { ns: "components/intro" })}

              {isIntersport && (
                <span style={arrowContainerStyle} aria-hidden>
                  <ChevronRight style={iconStyle} />
                </span>
              )}
            </div>
          </button>
          <ScanCTA
            nextStep={async () => {
              if (userContext) {
                const resultNewMeasure =
                  await userContext.createNewMeasure("scan");
                if (resultNewMeasure) {
                  setStep(MODAL_STEPS.QR_CODE);
                  setPreviousStep(MODAL_STEPS.BELLY);
                }
              }
            }}
          />
        </div>
        <MeasuredBy step={step} />
      </div>
    </>
  );
};

export default StepBelly;
